export default __webpack_public_path__ + "static/media/ny-cityguide-06.c25bb4de.jpg";